import React from 'react';
import { PawPrint } from 'lucide-react';
export function Footer() {
  return <footer className="bg-stone-900 text-stone-400 py-12 px-6 text-center" data-id="element-41">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-42">
        <div className="flex items-center gap-2 text-stone-300 mb-6 opacity-50" data-id="element-43">
          <PawPrint className="w-5 h-5" data-id="element-44" />
          <span className="font-sans font-bold text-lg tracking-tight" data-id="element-45">
            Napftagebuch
          </span>
        </div>

        <p className="text-xs font-sans max-w-md mx-auto leading-relaxed opacity-60" data-id="element-46">
          Dieser Beitrag enthält Werbung. Die beschriebenen Erfahrungen sind
          persönlich, Ergebnisse können individuell variieren. Bei anhaltenden
          gesundheitlichen Problemen deines Hundes konsultiere bitte immer einen
          Tierarzt.
        </p>

        <div className="mt-8 flex gap-4 text-xs font-sans opacity-60" data-id="element-47">
          <a href="#" className="hover:text-stone-200 transition-colors" data-id="element-48">
            Impressum
          </a>
          <a href="#" className="hover:text-stone-200 transition-colors" data-id="element-49">
            Datenschutz
          </a>
          <a href="#" className="hover:text-stone-200 transition-colors" data-id="element-50">
            AGB
          </a>
        </div>
      </div>
    </footer>;
}